import Header from "../Components/Header"
import Footer from "../Components/Footer"
import { MultiTypeBlock1, CheckboxBlocks, SubmitAndClear, MultiTypeBlock2, MultiTypeBlock3, MultiCheckboxBlocks, ZoneCheckboxes} from "../Components/FilterBlocks"
import { resolveFilmroomPlateData, wrapFilterRequestData } from "../Utils/DataProcess"
import { useEffect, useRef, useState } from "react"
import { useForm, FormProvider } from 'react-hook-form'
import { api_getFilterResult, api_getPlayerRoster } from "../axios"
import { MessageModal } from "../Components/Modals/MessageModal"
import Loading from "../Components/Loading"
import { resolvePlayerAutoCompleteList } from "../Utils/RosterUtils"
import { VideoPlayer } from "../Components/FilmroomComponents"
import { VideoEntryRow, VideoOptionSnippet, VideoPlateEntryRow } from "../Components/VideoEntry"
import { downloadVideos, wrapVideoDownloadInfo } from "../Utils/DownloadUtils"

const menuRow1 = [{
  title:"年份", key: "Year", options:[2024, 2023, 2022]}, {title:"裁判", key: "Umpire",
  options:["", "林金達", "紀華文", "蘇建文", "羅鈞鴻", "邱景彥", "彭楚雲", "蔡豐澤", "江春緯", "吳家維", "王俊宏", "張展榮", "楊崇煇", "尤志欽", "陳均瑋", "范元淦"]
}]
const menuRow2 = {
  title:"投球結果", key: "PCList",
  cols: [
    {colClass:"col3", boxes:["壞球", "好球(揮空)", "好球(沒揮)"]},
    {colClass:"col3", boxes:["界外", "擊進場內", "所有揮擊"]}
  ]
}
const ruleRow2 = {
  "所有揮擊": ["好球(揮空)", "界外", "擊進場內"]
}

const menuRow3 = {
  title:"擊球型態", key: "HTList",
  cols: [
    {colClass:"col3", boxes:["滾地球", "平擊球", "所有飛球"]},
    {colClass:"col3", boxes:["內野飛球", "高飛球"]}
  ]
}
const ruleRow3 = {
  "所有飛球": ["內野飛球", "高飛球"]
}

const menuRow4 = {
  title:"打席結果", key: "PRList",
  cols: [
    {colClass: "col3", boxes:["三振", "四壞球", "觸身球"]},
    {colClass:"col3", boxes:["安打", "一壘安打", "二壘安打"]},
    {colClass:"col3", boxes:["", "三壘安打", "全壘打"]},
    {colClass:"col3", boxes:["出局", "飛球出局", "滾地球出局"]},
    {colClass:"col3", boxes:["", "雙殺打", "三殺打"]},
    {colClass:"col3", boxes:["失誤", "犧飛(含失誤)", "犧觸(含失誤)"]},
  ]
}

const ruleRow4 = {
  "安打": ["一壘安打", "二壘安打", "三壘安打", "全壘打"],
  "出局": ["飛球出局", "滾地球出局", "雙殺打", "三殺打"]
}

const menuRow5 = {
  title:"擊球強度", key: "Hardness",
  cols: [
    {colClass:"col3", boxes:["強勁","一般", "軟弱"]},
    {colClass:"col3 font-small", boxes:["Barrels","Solid Contact", "Flares & Bumers"]},
    {colClass:"col3 font-small", boxes:["Topped", "Hit under","Weak Contact"]}
  ]
}

const menuRow6 = {
  title:"球數狀況", key: "BSList",
  cols: [
    {colClass:"col3", boxes:["平手", "投手領先", "打者領先"],},
    {colClass:"col3", boxes:["0-0", "1-1", "2-2"]},
    {colClass:"col3", boxes:["0-1", "0-2", "1-2"]},
    {colClass:"col3", boxes:["1-0", "2-0", "2-1"]},
    {colClass:"col3", boxes:["3-0", "3-1", "3-2"]},
  ]
}
const ruleRow6 = {
  "投手領先": ["0-1", "0-2", "1-2"],
  "打者領先": ["1-0", "2-1", "2-0", "3-0", "3-1"],
  "平手": ["0-0", "1-1", "2-2"]
}

const sheet = {
  discipline: {
    headers: ['Type', 'Total#','Total%','Strike#','Strike%','Zone#','Zone%','Swing#','Swing%','好球揮棒率','Z-Swing%','O-Swing%','Contact#','Contact%','Z-Contact%','O-Contact%','Whiff#','Whiff%','Swtr%','In-Play#','In-Play%'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
    ]
  }, 
  score: {
    headers: ['Type', 'Avg', 'Avg L', 'Avg R', 'OBP', 'SLG', 'OPS', 'BABIP', 'K%', 'BB%', 'G', 'PA', 'AB', 'H', 'XBH', 'HR', 'TB', 'K', 'BB'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
      //{title: "直球", data:[0.233, 0.222, 0.267, 0.442, 0.452, 0.894, 0.288, '10%', '5%', 12, 109, 90, 22, 7, 1, 17, 11, 6]}
    ]
  },
  hit: {
    headers: ['Type', 'GB%', 'LD%', 'FB%', 'IFFB%', 'HardHit%', 'SweetSpot%', 'Weak%', 'Topped%', 'Under%', 'Flare/Burner', 'Solid%', 'Barrel%', 'Soft%', 'Med%', 'Hard%', 'Pull%', 'Straight%', 'Oppo%'],
    data: [
      {title: "", data:['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
      //{title: "滑球", data:['20%', "50%", "60%", "15%", "20%", "30%", "10%", "15%", "60%", "15%", "20%", "30%", "10%", "15%", "10%", '10%', '10%']}
    ]
  }
}
const ptypes = [["四縫FB", "伸卡FT", "快速指叉SFF"], ["滑球SL", "曲球CB", "卡特CT"], ["變速CH", "指叉SP", "慢速曲球SC"], ["蝴蝶KN", "其他OT"]]

const clearField = {
  Year: "2024",
  Batter: "",
  BatSList: false,
  Pitcher: "",
  Catcher: "",
  Umpire: "",
  OList: false,
  OBList: false,
  TagPList: false,
  ZBList: false,
  Hardness: false,
  timemode: 'year',
  Bteam: "全部隊伍",
  Pteam: "全部隊伍"
}


const Filmroom = () => {
  const multi_cam = ['gamevideo', 'cam3', 'cam1', 'cam4', 'cam8', 'cam7']
  const [modalMsg, setModalMsg] = useState('')
  const [modalVis, setModalVis] = useState(false)
  const [loading, setLoading] = useState(true)
  const [acmap, setACMap] = useState({ BatterACOptionMap: [], CatcherACOptionMap: [], PitcherACOptionMap: [] })
  const [vconfig, setVconfig] = useState({})
  const [videoAvailable, setVideoAvailable] = useState(true)
  const [filteredData, setFilteredData] = useState([])
  const [url, setURL] = useState('')
  const [selected, setSelected] = useState('')
  const [vindex, setVindex] = useState(null)
  const [mode, setMode] = useState('balls')
  const [download, setDownload] = useState([])
  const [selectedCam, setSelectedCam] = useState(0)
  const methods = useForm()
  const playerRef = useRef(null)
  

  useEffect(() => {
    const loadPreData = async () => {
      const playerInfo = await api_getPlayerRoster()
      if (playerInfo.status === 'error') {
        setLoading(false)
        setModalMsg({type: 'error', msg: playerInfo.message})
        setModalVis(true);
        return false
      } else {
        return resolvePlayerAutoCompleteList(playerInfo.data)
      }
    }
    loadPreData().then((load_data) => {
      if (!load_data) return;
      setACMap(load_data)
      setLoading(false)
    })
  }, [])

  const handleOnSubmit = async (data) => {
    setLoading(true)
    let pdata = {...wrapFilterRequestData(data), GameType: [1000]}
    const filterRes = await api_getFilterResult({data: pdata, mode})
    if (filterRes.status === 'error') {
      setLoading(false)
      setModalMsg({type: 'error', msg: filterRes.message})
      setModalVis(true);
    } else { // TODO: success operations
      if (filterRes.data.length === 0) {
        setLoading(false)
        setModalMsg({type: 'error', msg: "查無相關資料"})
        setModalVis(true);
      } else {
        filterRes.data.sort((a,b)=>(b.GameNo-a.GameNo))
        try {
          if (mode === 'plates') setFilteredData(resolveFilmroomPlateData(filterRes.data))
          else setFilteredData(filterRes.data)
          setLoading(false)
          setDownload(new Array(filterRes.data.length * multi_cam.length).fill(false))
        } catch (e) {
          console.log(e)
          setLoading(false)
          setModalMsg({type: 'error', msg: "發生問題, 請聯絡工作人員"})
          setModalVis(true);
        }
      }
    }
    // methods.reset(clearField)
    window.scrollTo(0, 0)
  }

  const cams_mode = { balls: ["轉播視角", "左打視角", "右打視角", "後方視角", "左投視角", "右投視角"], plates: ["轉播視角"]}

  return (
    <FormProvider {...methods}>
      <MessageModal type={modalMsg.type} message={modalMsg.msg} visible={modalVis} setVisible={setModalVis} /> 
      <Loading visible={loading} />
      <Header />
      <div className="wrapper">
        <form className="filter_menu" onSubmit={methods.handleSubmit(handleOnSubmit)}>
          <div className="filmroom-mode-wrapper">
            <div className="filmroom-mode-switcher">
              <div className={"filmroom-mode"+(mode==='balls'?" selected_mode":"")} onClick={()=>{methods.reset(clearField);setMode('balls');setVindex(null);setFilteredData([]);}}>逐球</div>
              <div className={"filmroom-mode"+(mode==='plates'?" selected_mode":"")} onClick={()=>{methods.reset(clearField);setMode('plates');setVindex(null);setFilteredData([]);}}>逐打席</div>
            </div>
          </div>
          {
            mode === "balls" ?
              <>
                <MultiTypeBlock1 contents={menuRow1} acmap={acmap} />
                <MultiCheckboxBlocks content={menuRow2} rule={ruleRow2} />
                <MultiCheckboxBlocks content={menuRow3} rule={ruleRow3} />
                <MultiCheckboxBlocks content={menuRow4} rule={ruleRow4} />
                <CheckboxBlocks content={menuRow5} />
                <MultiTypeBlock2 />
                <MultiCheckboxBlocks content={menuRow6} rule={ruleRow6} />
                <ZoneCheckboxes />
                <MultiTypeBlock3 content={ptypes} />
                <SubmitAndClear clearField={clearField} />
              </> :
              <>
                <MultiTypeBlock1 contents={menuRow1} acmap={acmap} />
                <MultiCheckboxBlocks content={menuRow3} rule={ruleRow3} />
                <MultiCheckboxBlocks content={menuRow4} rule={ruleRow4} />
                <CheckboxBlocks content={menuRow5} />
                <MultiTypeBlock2 />
                <SubmitAndClear clearField={clearField} />
              </>
          }
        </form>
        <div className="filter">
          <VideoPlayer playerRef={playerRef} vconfig={vconfig} videoAvailable={videoAvailable} setVideoAvailable={setVideoAvailable} url={url} />
          <div className="download-info">
            {/* <span style={{whiteSpace:'nowrap'}}>已選擇 {download.filter((e) => (e)).length} 部影片</span> */}
            <button onClick={(e) => downloadVideos(mode, download.filter((e) => (e)), multi_cam, setModalMsg, setModalVis)} disabled={download.filter((e) => (e)).length === 0}>
              下載所選{download.filter((e) => (e)).length}部影片
            </button>
            <button onClick={(e) => setDownload(new Array(filteredData.length).fill(false))}>清除</button>
            <button onClick={(e) => downloadVideos(mode, filteredData.map((e) => (wrapVideoDownloadInfo(mode, e, cams_mode[mode][0]))), multi_cam, setModalMsg, setModalVis)}>下載全部</button>
            {vindex !== null &&
              <>
                {cams_mode[mode].map((e, i) => <VideoOptionSnippet mode={mode} title={e} playing={selectedCam === i} index={vindex * multi_cam.length + i} camindex={i} checked={download} setSelectedCam={setSelectedCam} setDownload={setDownload} setURL={setURL} setAvailable={setVideoAvailable} data={filteredData[vindex]} cams={multi_cam} />)}
              </>
            }
          </div>
          <div className="filter_video_res">
            {
              mode === 'balls' ? filteredData.map((e, i) => <VideoEntryRow setURL={setURL} setAvailable={setVideoAvailable} data={e} selectedEntry={selected} setSelectedEntry={setSelected} checked={download} index={i} setDownload={setDownload} cams={multi_cam} selectedCam={selectedCam} setSelectedCam={setSelectedCam} setIndex={setVindex} />) 
              : filteredData.map((e, i) => <VideoPlateEntryRow setURL={setURL} setAvailable={setVideoAvailable} data={e} selectedEntry={selected} setSelectedEntry={setSelected} checked={download} index={i} setDownload={setDownload} setIndex={setVindex} />)
            }
          </div>
        </div>
      </div>
      <Footer />
    </FormProvider>
  )
}

export default Filmroom